import React from 'react';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';

export const ConfirmQuoteStep = ({
    stepState,
    stepData,
    onShowEmailModal,
    onConfirmQuote,
    getStatusText,
    getStepIconColor,
    disabled,
    tooltip
}) => {
    const stepIconConfirm = getStepIconColor(stepState);
    return (
        <>
            <div className="step-content-box">
                {/* ... (rest of content) */}
                <i className="pi pi-file-check text-6xl mb-3" style={{ color: '#21588C' }}></i>
                <h3 className="m-0 mb-2">Aprobación</h3>
                <p className="text-gray-600 text-center m-0">
                    {stepState === 'completed' ? 'Aprobación completada' : 'Revisa y aprueba los detalles antes de continuar.'}
                </p>

                <div className={`step-status-badge status-${stepState}`}>
                    <i className={stepIconConfirm.icon}></i>
                    <span>{getStatusText(stepState)}</span>
                </div>

                {/* Mostrar archivos enviados si existen */}
                {stepData && stepData.files && stepData.files.length > 0 && (
                    <div className="w-full mt-4">
                        <h4 className="text-gray-700 mb-2 text-center">Archivos Enviados:</h4>
                        <div className="flex flex-wrap gap-2 justify-content-center">
                            {stepData.files.map((file, index) => (
                                <div key={index} className="flex align-items-center gap-2 p-2 border-1 border-gray-200 border-round bg-white shadow-1" style={{ minWidth: '200px', maxWidth: '300px' }}>
                                    <div className="flex align-items-center gap-2 overflow-hidden flex-1">
                                        <i className="pi pi-file-pdf text-red-500 text-xl"></i>
                                        <span className="text-sm text-gray-800 white-space-nowrap overflow-hidden text-overflow-ellipsis" title={file.file_name}>
                                            {file.file_name}
                                        </span>
                                    </div>
                                    {file.s3_url && (
                                        <a
                                            href={file.s3_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="p-button p-button-rounded p-button-text p-button-sm flex-shrink-0"
                                            title="Ver archivo"
                                        >
                                            <i className="pi pi-eye text-blue-600"></i>
                                        </a>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}


                <Tooltip target=".disabled-tooltip-wrapper" />
                <span
                    className={`mt-4 w-full inline-block disabled-tooltip-wrapper ${disabled ? 'cursor-not-allowed' : ''}`}
                    data-pr-tooltip={tooltip}
                    data-pr-position="top"
                >

                    {/*  <Button
                        label={stepState === 'completed' ? "Ver correo de confirmación" : "Enviar correo de confirmación"}
                        className="Button Blue mt-1 p-2"
                        icon="pi pi-eye"
                        onClick={onShowEmailModal}
                        disabled={disabled}
                        tooltipOptions={{ position: 'top' }}
                        style={{ pointerEvents: disabled ? 'none' : 'auto' }}
                    /> */}
                </span>
            </div>
            <div className="flex pt-4 justify-content-end">
                <Button
                    label={stepState === 'completed' ? "Ver correo de confirmación" : "Enviar correo de confirmación"}
                    className="Button Green"
                    icon="pi pi-eye"
                    onClick={onShowEmailModal}
                    disabled={disabled}
                    tooltipOptions={{ position: 'top' }}
                    style={{ pointerEvents: disabled ? 'none' : 'auto', border: 'none', outline: 'none' }}
                />
            </div >
        </>
    );
};
